import { FindEstoqueUseCase } from '@/usecases/deposito/FindEstoqueUseCase'

export type StatusDaConferencia = 'disponivel' | 'sem-estoque' | 'falha'

export type StatusDoItemNoCarrinho = StatusDaConferencia | 'conferindo'

export interface ConferenciaDoCarrinho {
	emAndamento: boolean
	conferidas: number
	total: number
	statusPorSku: Record<string, StatusDoItemNoCarrinho>
}

interface ParametrosDaConferencia {
	lojaId: string
	quantidadePorSku: Record<string, number>
	referenciaPorSku: Record<string, string>
	findEstoqueUseCase?: FindEstoqueUseCase
	aoConferirReferencia?: (statusPorSku: Record<string, StatusDaConferencia>) => void
}

export async function conferirDisponibilidadeNaVitrineVirtual({
	lojaId,
	quantidadePorSku,
	referenciaPorSku,
	findEstoqueUseCase = new FindEstoqueUseCase(),
	aoConferirReferencia,
}: ParametrosDaConferencia): Promise<Record<string, StatusDaConferencia>> {
	const skusPorReferencia = Object.keys(quantidadePorSku).reduce((grupos, sku) => {
		const referencia = referenciaPorSku[sku] ?? sku
		return { ...grupos, [referencia]: [...(grupos[referencia] ?? []), sku] }
	}, {} as Record<string, string[]>)

	const statusPorSku: Record<string, StatusDaConferencia> = {}
	const inicioDaConferencia = performance.now()
	const referencias = Object.keys(skusPorReferencia)

	console.info(`[Vitrine Virtual] Conferência iniciada: ${referencias.length} referência(s) em paralelo`)

	await Promise.all(
		referencias.map(async referencia => {
			const skusDaReferencia = skusPorReferencia[referencia]
			const inicioDaReferencia = performance.now()
			const quantidadeDaReferencia = skusDaReferencia.reduce(
				(quantidades, sku) => ({ ...quantidades, [sku]: quantidadePorSku[sku] }),
				{} as Record<string, number>,
			)

			let statusDaReferencia: Record<string, StatusDaConferencia>

			try {
				const skusSemEstoque = new Set(
					await findEstoqueUseCase.buscarSkusSemEstoqueNaVitrineVirtual(lojaId, quantidadeDaReferencia),
				)
				statusDaReferencia = skusDaReferencia.reduce((status, sku) => ({
					...status,
					[sku]: skusSemEstoque.has(sku) ? 'sem-estoque' : 'disponivel',
				}), {} as Record<string, StatusDaConferencia>)
				console.info(
					`[Vitrine Virtual] Referência ${referencia} (${skusDaReferencia.length} SKU): ` +
					`${Math.round(performance.now() - inicioDaReferencia)} ms, sem estoque: ${skusSemEstoque.size}`,
				)
			} catch (error) {
				statusDaReferencia = skusDaReferencia.reduce((status, sku) => ({
					...status,
					[sku]: 'falha',
				}), {} as Record<string, StatusDaConferencia>)
				console.warn(
					`[Vitrine Virtual] Referência ${referencia} (${skusDaReferencia.length} SKU): ` +
					`FALHA após ${Math.round(performance.now() - inicioDaReferencia)} ms`,
					error,
				)
			}

			Object.assign(statusPorSku, statusDaReferencia)
			aoConferirReferencia?.(statusDaReferencia)
		}),
	)

	console.info(
		`[Vitrine Virtual] Conferência concluída: ${referencias.length} referência(s) em ` +
		`${Math.round(performance.now() - inicioDaConferencia)} ms (a mais lenta define o total)`,
	)

	return statusPorSku
}
